import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-form"
export default class extends Controller {
  static targets = [
    "nameInput",
    "nameLength",
    "namePreviewText",
    "previewAlbumName",
    "preview"
  ]

  static values = {
    sourceAlbumName: String
  }

  connect() {
    this.updateCharacterCount()
    this.updateNamePreview()
  }

  nameInputChanged() {
    this.updateCharacterCount()
    this.updateNamePreview()
  }

  updateNamePreview() {
    const customName = this.nameInputTarget.value.trim()
    let displayName

    if (customName.length > 0) {
      displayName = customName
      this.namePreviewTextTarget.textContent = 'Custom name: '
    } else {
      // Generate default name
      displayName = `Copy of ${this.sourceAlbumNameValue}`
      this.namePreviewTextTarget.textContent = 'Auto-generated: '
    }

    this.previewAlbumNameTarget.textContent = displayName
  }

  updateCharacterCount() {
    const length = this.nameInputTarget.value.length
    this.nameLengthTarget.textContent = length

    // Remove all classes first
    this.nameLengthTarget.classList.remove('text-red-600', 'text-yellow-600')

    if (length > 120) {
      this.nameLengthTarget.classList.add('text-red-600')
    } else if (length > 100) {
      this.nameLengthTarget.classList.add('text-yellow-600')
    }
  }
}